import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const glow = keyframes`
  0%, 100% { box-shadow: 0 0 8px rgba(76, 175, 80, 0.3); }
  50% { box-shadow: 0 0 16px rgba(76, 175, 80, 0.6); }
`;

const glowGold = keyframes`
  0%, 100% { box-shadow: 0 0 8px rgba(218, 165, 32, 0.3); }
  50% { box-shadow: 0 0 16px rgba(218, 165, 32, 0.6); }
`;

const Strip = styled.div`
  background: #FFFFFF;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid rgba(218, 165, 32, 0.1);
  position: sticky;
  top: 56px;
  z-index: 99;
  box-shadow: 0 2px 8px rgba(139, 105, 20, 0.04);

  @media (max-width: 600px) {
    padding: 8px 10px;
    gap: 8px;
    top: 46px;
  }
`;

const CTAButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  border-radius: 10px;
  border: 1.5px solid ${p => p.variant === 'chat' ? 'rgba(76,175,80,0.4)' : 'rgba(218,165,32,0.4)'};
  background: ${p => p.variant === 'chat'
    ? 'rgba(76,175,80,0.06)'
    : 'rgba(218,165,32,0.06)'};
  color: ${p => p.variant === 'chat' ? '#2e7d32' : '#8B6914'};
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: ${p => p.variant === 'chat' ? glow : glowGold} 3s ease-in-out infinite;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    background: ${p => p.variant === 'chat'
      ? 'rgba(76,175,80,0.12)'
      : 'rgba(218,165,32,0.12)'};
  }

  @media (max-width: 600px) {
    padding: 6px 16px;
    font-size: 0.78rem;
    gap: 6px;
  }
`;

const Emoji = styled.span`
  font-size: 1.1rem;
`;

const LiveDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4caf50;
  animation: ${glow} 2s ease-in-out infinite;
`;

const AstrologerCTA = () => {
  const navigate = useNavigate();

  return (
    <Strip>
      <CTAButton variant="chat" onClick={() => navigate('/talk-to-astrologer')}>
        <Emoji>💬</Emoji>
        Chat with Astrologer
        <LiveDot />
      </CTAButton>
      <CTAButton variant="call" onClick={() => navigate('/talk-to-astrologer')}>
        <Emoji>📞</Emoji>
        Call an Astrologer
      </CTAButton>
    </Strip>
  );
};

export default AstrologerCTA;
